import React from "react";
function PerformaReport(props) {
  const [value, setValue] = React.useState(null);

  const [IsStyle, SetStyle] = React.useState("form-control construction");
  const [structureType, SetstructureType] = React.useState("Per Home");
  React.useEffect(() => {

    if (props.structureType == "Single Family") { SetstructureType("Per Lot") }
    if (props.structureType == "Apartment" || props.structureType == "Condo") { SetstructureType("Per Unit") }
    if (props.value == "") {
      setValue(0);
    }
    else {
      setValue(props.value);
    }
    if (props.id == 167 || props.id == 143 || props.id == 146) {
      SetStyle("form-control construction leftTop");
    }
    if (props.id == 166) {
      SetStyle("form-control construction RightTop");
    }
    if (props.id == 156 || props.id == 157 || props.id == 158) {
      SetStyle("form-control construction leftBottom");
    }
    if (props.id == 159) {
      SetStyle("form-control construction RightBottom");
    }
    if (props.id == 226) {
      SetStyle("form-control construction leftTop leftBottom");
    }
    if (props.id == 248) {
      SetStyle("form-control construction RightBottom RightTop");
    }
    if (props.id == 181) {
      SetStyle("form-control");
    }
  }, []);






  if (props.id == 187 || props.id == 214 || props.id == 225) {
    //if(props.id==225){UpdateParameterValues(props.structureType,props);}
    return (
      <>
        <div class="row" style={{ width: "100%", marginBottom: "1%" }}>

          <div class="col-md-9 col-9" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="ReportPerviewLabel" ><b style={{ fontSize: "14px" }}>{props.name.split('Per')[0]} </b>


              </div>



            </div>
          </div>

          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                <b style={{ fontSize: "14px" }}> {value} % </b>
              </div>

            </div>
          </div>
        </div>

      </>
    )

  }

  if (props.id == 146 || props.id == 143 || props.id == 167 || props.id == 166) {

    if (props.id == 146 || props.id == 143 || props.id == 167) {
      return (

        <>
          <div class="col-md-12 ">
            <div class="row" style={{ width: "102%", marginBottom: "2%" }}>
              <div class="col-md-6 col-6"></div>
              <div class="col-md-3 col-3"><div class="ReportPerviewLabel " style={{ float: "left" }}>{structureType}</div></div>
              <div class="col-md-3 col-3"><div class="ReportPerviewLabel  ">Project</div></div>
            </div>

          </div>

          <div class="col-md-6 col-6 from  d-flex justify-content-between  align-items-center ">
            <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
            </div>



          </div>
          <div class="col-md-3 col-3 from  d-flex justify-content-between  align-items-center ">

            <div class="ReportPerviewLabel" >
              $ {value}
            </div>
          </div>

        </>
      );
    }
    else {
      return (

        <>

          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 125 || props.id == 127 || props.id == 161 || props.id == 182) {
    if (props.id == 125 || props.id == 127 || props.id == 161) {
      return (

        <>

          <div class="col-md-6 col-6 from  d-flex justify-content-between  align-items-center ">
            <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
            </div>



          </div>
          <div class="col-md-3 col-3 from  d-flex justify-content-between  align-items-center ">

            <div class="ReportPerviewLabel" >
              $ {value}
            </div>
          </div>

        </>
      );
    }
    else {
      return (

        <>

          <div class="col-md-3 col-3">
            <div class="= from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 135 || props.id == 137 || props.id == 139 || props.id == 141) {
    if (props.id == 135 || props.id == 137 || props.id == 139) {
      return (

        <>

          <div class="col-md-6  col-6 from  d-flex justify-content-between  align-items-center ">
            <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
            </div>



          </div>
          <div class="col-md-3 col-3 from  d-flex justify-content-between  align-items-center ">

            <div class="ReportPerviewLabel" >
              $ {value}
            </div>
          </div>

        </>
      );
    }
    else {
      return (

        <>

          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>
        </>
      );


    }

  }
  if (props.id == 122 || props.id == 149 || props.id == 151 || props.id == 123) {
    if (props.id == 122 || props.id == 149 || props.id == 151) {
      return (

        <>

          <div class="col-md-6 col-6 from  d-flex justify-content-between  align-items-center ">
            <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
            </div>



          </div>
          <div class="col-md-3  col-3 from  d-flex justify-content-between  align-items-center ">

            <div class="ReportPerviewLabel" >
              $ {value}
            </div>
          </div>

        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>

        </>
      );


    }

  }
  if (props.id == 153 || props.id == 154 || props.id == 50 || props.id == 155) {
    if (props.id == 153 || props.id == 154 || props.id == 50) {
      return (

        <>

          <div class="col-md-6 col-6" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
              </div>



            </div>
          </div>

          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center ">

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>

        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>

        </>
      );


    }

  }
  if (props.id == 163 || props.id == 164 || props.id == 183 || props.id == 162) {
    if (props.id == 163 || props.id == 164 || props.id == 183) {
      return (

        <>

          <div class="col-md-6 col-6" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
              </div>



            </div>
          </div>

          <div class="col-md-3 col-3">
            <div class="from   d-flex justify-content-between  align-items-center ">
              <div class="">
                <div class="ReportPerviewLabel" >
                  $ {value}
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                $ {value}
              </div>
            </div>
          </div>






          <div class="row" style={{ width: "100%" }}>

            <div class="col-md-12" style={{ marginTop: "5%", marginBottom: "5%", borderTop: "1px solid white" }}></div>
          </div>
        </>

      );


    }

  }
  if (props.id == 156 || props.id == 157 || props.id == 158 || props.id == 159) {
    if (props.id == 156 || props.id == 157 || props.id == 158) {
      return (

        <>

          <div class="col-md-6 col-6" >
            <div class="from  d-flex justify-content-between  align-items-center ">
              <div class="ReportPerviewLabel" > <b style={{ fontSize: "14px" }}>{props.name.split('Per')[0]}</b>
              </div>



            </div>
          </div>

          <div class="col-md-3 col-3">
            <div class="from  d-flex justify-content-between  align-items-center ">

              <div class="ReportPerviewLabel" >
                <b style={{ fontSize: "14px" }}> $ {value}</b>
              </div>
            </div>
          </div>

        </>
      );
    }
    else {
      return (

        <>


          <div class="col-md-3 col-3 mb-3">
            <div class="from  d-flex justify-content-between  align-items-center " style={{ float: "right" }}>

              <div class="ReportPerviewLabel" >
                <b style={{ fontSize: "14px" }}> $ {value}</b>
              </div>
            </div>
          </div>


        </>
      );


    }

  }
  else {

    return (
      <>
        <div class="col-md-6 col-6">
          <div class="from  d-flex justify-content-between  align-items-center ">
            <div class="ReportPerviewLabel" >{props.name.split('Per')[0]}
            </div>



          </div>
        </div>
        <div class="col-md-3 col-3">
          <div class="from  d-flex justify-content-between  align-items-center ">

            <div class="ReportPerviewLabel" >
              $ {value}
            </div>
          </div>
        </div>
      </>
    );
  }
}
export default PerformaReport;
